import { API_CONFIG, storage, STORAGE_KEYS, RESPONSE_CODE } from './config';
import req from '@/utils/req'

// 全局单例变量，确保只有一个WebSocket实例
let wsInstance = null;

class WebSocketClient {
  constructor() {
    // 如果已经存在实例，直接返回该实例
    if (wsInstance) {
      return wsInstance;
    }
    
    this.ws = null;
    // this._url = `ws://${window.location.hostname}:${window.location.port}${API_CONFIG.BASE_URL}/ws`;
    this._url = ''
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectInterval = 3000;
    this.messageCallbacks = new Set();
    this.heartbeatTimer = null;
    this.heartbeatInterval = 10000; // 10秒发送一次心跳
    this.params = {}; // 存储URL参数
    this.headers = {}; // 存储请求头参数
    this.datajson = {};
    this.connected = false; // 标记是否已连接
    
    // 保存实例到全局变量
    wsInstance = this;
    
    console.log('WebSocketClient单例已创建');
    this.reqUrl()
  }

  reqUrl() {
    let userInfo = storage.get(STORAGE_KEYS.USER_INFO)
    if (!userInfo || !(userInfo instanceof Object) || !userInfo.kf_id) {
      console.warn('用户信息不完整，无法建立WebSocket连接');
      return;
    }
    req.request({
      url: '/Setting/get',
      method: 'post',
      data: {uid: userInfo.kf_id}
    }).then(res => {
      if (res.code != RESPONSE_CODE.SUCCESS) {
        return;
      }

      if (res.data.ws_address && res.data.ws_address != '' && res.data.appkey && res.data.appkey != '') {
        let url = res.data.ws_address + "/app/" + res.data.appkey + "?protocol=7&client=js&version=1.1.0&flash=false"
        this.updateUrl(url, {"kefu": userInfo})
      }
    })
  }

  // 获取当前WebSocket URL
  get url() {
    return this._url;
  }

  // 设置新的WebSocket URL
  set url(newUrl) {
    if (this._url === newUrl) return;
    
    console.log(`更新WebSocket URL: ${this._url} -> ${newUrl}`);
    this._url = newUrl;
    
    // 如果当前有活跃连接，则重新连接
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.reconnectAttempts = 0; // 重置重连次数
      this.close(); // 关闭当前连接
      this.connect(); // 建立新连接
    } else {
      this.reconnectAttempts = 0; // 重置重连次数
      this.close(); // 关闭当前连接
      this.connect();
    }
  }

  // 更新WebSocket URL并重新连接
  updateUrl(newUrl, datajson) {
    console.log(`通过updateUrl方法更新WebSocket连接: ${newUrl}`);
    this.url = newUrl;
    this.datajson = datajson || {};
    return this; // 支持链式调用
  }

  // 设置URL参数
  setParams(params = {}) {
    const userInfo = storage.get(STORAGE_KEYS.USER_INFO)
    if (userInfo && userInfo instanceof Object) {
        this.params = { 
            bid: userInfo.bid,
            kf_id: userInfo.kf_id,
            cid: userInfo.cid,
            groupid: userInfo.groupid,
        };
    }
    this.params = { ...this.params, ...params};
    return this;
  }

  // 清除URL参数
  clearParams() {
    this.params = {};
    return this;
  }

  // 设置请求头参数
  setHeaders(headers = {}) {
    this.headers = { ...this.headers, ...headers };
    return this;
  }

  // 清除请求头参数
  clearHeaders() {
    this.headers = {};
    return this;
  }

  // 构建完整的URL（包含参数）
  getFullUrl() {
    let fullUrl = this._url;
    const queryParams = new URLSearchParams();
    
    // 添加URL参数
    Object.entries(this.params).forEach(([key, value]) => {
      queryParams.append(key, value);
    });
    
    const queryString = queryParams.toString();
    if (queryString) {
      fullUrl += (fullUrl.includes('?') ? '&' : '?') + queryString;
    }
    
    return fullUrl;
  }

  // 连接WebSocket
  connect() {
    // 防止重复连接
    if (this.connected && this.ws && this.ws.readyState === WebSocket.OPEN) {
      console.log('WebSocket已连接，不需要再次连接');
      return;
    }
    
    let userInfo = storage.get(STORAGE_KEYS.USER_INFO)
    if (!userInfo || !(userInfo instanceof Object) || !userInfo.kf_id) {
      console.warn('用户信息不完整，无法建立WebSocket连接');
      return;
    }
    
    try {
      const fullUrl = this.getFullUrl();
      if (fullUrl === '') {
        console.error('WebSocket URL为空');
        return;
      }
      
      console.log('正在连接WebSocket:', fullUrl);
      
      // 关闭可能存在的连接
      this.close();
      
      // 如果有请求头参数，需要使用自定义协议
      if (Object.keys(this.headers).length > 0) {
        // 将请求头转换为协议数组
        const protocols = [];
        const headerString = JSON.stringify(this.headers);
        protocols.push(`headers:${btoa(headerString)}`);
        
        this.ws = new WebSocket(fullUrl, protocols);
      } else {
        this.ws = new WebSocket(fullUrl);
      }
      
      this.bindEvents();
      this.startHeartbeat();
    } catch (error) {
      console.error('WebSocket连接失败:', error);
      this.connected = false;
      this.reconnect();
    }
  }

  // 绑定WebSocket事件
  bindEvents() {
    this.ws.onopen = () => {
      console.log('WebSocket连接成功');
      this.reconnectAttempts = 0;
      this.connected = true;
      
      // 连接成功后发送认证信息
      if (this.datajson && this.datajson.kefu && this.datajson.kefu instanceof Object) {
        console.log(`订阅频道: kefu-${this.datajson.kefu.kf_id}`);
        this.send({ event: 'pusher:subscribe', data: {'channel': 'kefu-' + this.datajson.kefu.kf_id}})
        this.send({ event: 'pusher:subscribe', data: {'channel': 'global-' + this.datajson.kefu.bid}})
      } else {
        console.warn('缺少kefu数据，无法订阅频道');
      }
    };

    this.ws.onclose = (event) => {
      console.log('WebSocket连接关闭');
      this.connected = false;
      
      if (event.wasClean) {
        console.log(`连接正常关闭，状态码: ${event.code}, 原因: ${event.reason}`);
      } else {
        console.log(`连接异常关闭，状态码: ${event.code}, 原因: ${event.reason}`);
        this.reconnect();
      }
      this.stopHeartbeat();
    };

    this.ws.onerror = (error) => {
      console.error('WebSocket错误:', error);
      this.connected = false;
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        // 如果是心跳响应，则不触发消息回调
        if (data.type === 'pusher:ping') {
          return;
        }
        this.messageCallbacks.forEach(callback => callback(data));
      } catch (error) {
        console.error('消息解析错误:', error);
      }
    };
  }

  // 重连机制
  reconnect() {
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.error('WebSocket重连次数超过最大限制');
      return;
    }

    setTimeout(() => {
      console.log(`尝试第${this.reconnectAttempts + 1}次重连...`);
      this.reconnectAttempts++;
      this.connect();
    }, this.reconnectInterval);
  }

  // 发送消息
  send(message) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      try {
        const messageString = typeof message === 'string' ? message : JSON.stringify(message);
        this.ws.send(messageString);
        return true;
      } catch (error) {
        console.error('发送消息失败:', error);
        return false;
      }
    } else {
      console.error('WebSocket未连接或状态异常', this.ws ? this.ws.readyState : 'null');
      // 尝试重新连接
      if (!this.connected) {
        console.log('尝试重新连接WebSocket...');
        this.connect();
      }
      return false;
    }
  }

  // 添加消息监听器
  onMessage(callback) {
    if (typeof callback === 'function') {
      this.messageCallbacks.add(callback);
    }
    return this; // 支持链式调用
  }

  // 移除消息监听器
  offMessage(callback) {
    this.messageCallbacks.delete(callback);
    return this; // 支持链式调用
  }

  // 开始心跳检测
  startHeartbeat() {
    this.stopHeartbeat(); // 先清除可能存在的心跳定时器
    this.heartbeatTimer = setInterval(() => {
      // this.send({ type: 'heartbeat', timestamp: Date.now() });
      this.send({ event: 'pusher:ping', data: {}})
    }, this.heartbeatInterval);
  }

  // 停止心跳检测
  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  }

  // 获取连接状态
  getState() {
    return this.ws ? this.ws.readyState : WebSocket.CLOSED;
  }

  // 判断是否已连接
  isConnected() {
    return this.connected && this.ws && this.ws.readyState === WebSocket.OPEN;
  }

  // 关闭连接
  close() {
    console.log('WebSocket 手动关闭')
    this.stopHeartbeat();
    this.connected = false;
    if (this.ws) {
      try {
        // 只有在连接开启或正在连接时才需要关闭
        if (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING) {
          this.ws.close();
        }
        this.ws = null;
      } catch (error) {
        console.error('关闭WebSocket连接出错:', error);
        this.ws = null;
      }
    }
    return this; // 支持链式调用
  }
  
  // 获取WebSocketClient单例实例
  static getInstance() {
    if (!wsInstance) {
      wsInstance = new WebSocketClient();
    }
    return wsInstance;
  }
}

// 创建单例并导出
const wsClient = WebSocketClient.getInstance();
export default wsClient; 